import { Map } from 'immutable';
import { REHYDRATE } from 'redux-persist/constants';

import * as EducationConstants from './constants';
import * as D from './deps';

const INITIAL_STATE = Map({
  [EducationConstants.ReducerKeys.LISTENERS]: Map(),
});

export default D.createReducer(INITIAL_STATE, {
  [REHYDRATE]: onRehydrate,
  [EducationConstants.ActionKeys.INCREMENT_PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT]:
    incrementPremiumAccessEducationWelcomeMessageCount,
  [EducationConstants.ActionKeys.INCREMENT_PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT]:
    incrementPremiumAccessEducationExitMessageCount,
  [EducationConstants.ActionKeys.UPDATE_WATCH_FOR_MTUP_UNLOCK]: onUpdateWatchForMtupUnlock,
  [EducationConstants.ActionKeys.UPDATE_MTUP_PLAYLIST_READY_FOR_MINICOACHMARK]:
    onUpdateMtupPlaylistReadyForMiniCoachmark,
  [D.Constants.Integrations.ActionTypes.FEEDBACK_ADDED]: incrementPositivePodcastFeedback,
  [D.Constants.Overlay.OVERLAY_ACTIONS.OPEN_OVERLAY]: openOverlay,
  [D.Constants.Overlay.OVERLAY_ACTIONS.HIDE_PODCAST_COLLECTIONS_COACHMARK]:
    hidePodcastCollectionCoachmark,
});

function onRehydrate(state, action) {
  return state.mergeDeep(action.payload.education);
}

function onUpdateWatchForMtupUnlock(state, { payload }) {
  return state.setIn([EducationConstants.ReducerKeys.WATCH_FOR_MTUP_PLAYLIST_UNLOCK], payload.flag);
}

function onUpdateMtupPlaylistReadyForMiniCoachmark(state, { payload }) {
  return state.setIn(
    [EducationConstants.ReducerKeys.MTUP_PLAYLIST_READY_FOR_MINICOACHMARK],
    payload.flag,
  );
}

function incrementPremiumAccessEducationMessageCount(state, action, reducerKey) {
  const listenerId = action.sharedState.listenerId;
  const path = [EducationConstants.ReducerKeys.LISTENERS, listenerId, reducerKey];
  const currentPodcastFeedbackCount = state.getIn(path, 0);
  return state.setIn(path, currentPodcastFeedbackCount + 1);
}

function incrementPremiumAccessEducationWelcomeMessageCount(state, action) {
  return incrementPremiumAccessEducationMessageCount(
    state,
    action,
    EducationConstants.ReducerKeys.PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT,
  );
}

function incrementPremiumAccessEducationExitMessageCount(state, action) {
  return incrementPremiumAccessEducationMessageCount(
    state,
    action,
    EducationConstants.ReducerKeys.PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT,
  );
}

function incrementPositivePodcastFeedback(state, action) {
  const listenerId = action.sharedState.listenerId;
  const currentPodcastFeedbackCount = state.getIn(
    [
      EducationConstants.ReducerKeys.LISTENERS,
      listenerId,
      EducationConstants.ReducerKeys.PODCAST_POSITIVE_FEEDBACK_COUNT,
    ],
    0,
  );
  const isPositivePodcastFeedback =
    D.Constants.SourceTypes.PodcastSourceTypes.includes(action.payload.sourceId) &&
    action.payload.isPositive;
  if (
    !isPositivePodcastFeedback ||
    currentPodcastFeedbackCount >= EducationConstants.MAX_PODCAST_POSITIVE_FEEDBACK_COUNT
  ) {
    return state;
  }

  return state.setIn(
    [
      EducationConstants.ReducerKeys.LISTENERS,
      listenerId,
      EducationConstants.ReducerKeys.PODCAST_POSITIVE_FEEDBACK_COUNT,
    ],
    currentPodcastFeedbackCount + 1,
  );
}

function openOverlay(state, action) {
  const listenerId = action.sharedState.listenerId;
  const overlayId = D.Utils.Overlay.getOverlayId(action.payload.overlayConfig);
  const showCount =
    state.getIn(
      [
        EducationConstants.ReducerKeys.LISTENERS,
        listenerId,
        overlayId,
        EducationConstants.ReducerKeys.SHOW_COUNT,
      ],
      0,
    ) + 1;

  return state.setIn(
    [
      EducationConstants.ReducerKeys.LISTENERS,
      listenerId,
      overlayId,
      EducationConstants.ReducerKeys.SHOW_COUNT,
    ],
    showCount,
  );
}

function hidePodcastCollectionCoachmark(state, action) {
  const listenerId = action.sharedState.listenerId;
  if (action.payload.isUnmount) {
    return state;
  }
  return state.setIn(
    [
      EducationConstants.ReducerKeys.LISTENERS,
      listenerId,
      `anchored_${D.Constants.MiniCoachmark.MiniCoachmarkTypes.FIRST_TIME_PODCAST_COLLECTIONS}`,
      EducationConstants.ReducerKeys.SHOW_COUNT,
    ],
    3,
  );
}
